
import { Map } from "@/store/enums/StoreEnums";
import { useStore } from 'vuex'
import { defineComponent, ref } from "vue";

export default defineComponent({
    name: "news-dropdown",
    props: {
        isEN: Boolean,
        isMobile: Boolean,
    },
    emits: ["enter", "leave"],
    setup() {
        const newsList = ref<any[]>([])
        const eventsList = ref<any[]>([])
        const store = ref(useStore())
        return {
            store,
            newsList,
            eventsList
        };
    },
    methods: {
        findAllNews() {
            this.store.dispatch(Map.findAllNews, {}).then(res => {
                if (res)
                    this.newsList = res
            })
        },

        findAllEvents() {
            this.store.dispatch(Map.findAllEvents, {}).then(res => {
                if (res)
                    this.eventsList = res
            })
        },

        enter() {
            this.$emit("enter")
        },
        leave() {
            this.$emit("leave")
        }
    },
    mounted() {
        this.findAllNews();
        this.findAllEvents();
        (this.$refs.newsDropDownRef as HTMLElement).addEventListener("mouseenter", this.enter);
        (this.$refs.newsDropDownRef as HTMLElement).addEventListener("mouseleave", this.leave);
    },
    unmounted() {
        if (this.$refs.newsDropDownRef) {
            (this.$refs.newsDropDownRef as HTMLElement).removeEventListener("mouseenter", this.enter);
        }
        if (this.$refs.newsDropDownRef) {
            (this.$refs.newsDropDownRef as HTMLElement).removeEventListener("mouseleave", this.leave);
        }
    }
})
